<form [formGroup]="form">
  <span translate>LEAD_GENERATION.SETTINGS.IS_MORE_THAN</span>
  <label>
    <input type="number" placeholder="{{'SECONDS' | translate}}" formControlName="time" class="light-grey-placeholder">
    <cc-input-errors
      [form]="form"
      inputName="time"
      [errors]="[{'numbers': 'Please enter a number'}]"></cc-input-errors>
  </label>
</form>
